export function getErrorMessage(error) {
  if (!error) return 'An unknown error occurred';

  // Axios error — response body has message/error field
  if (error.response?.data?.message) return error.response.data.message;
  if (error.response?.data?.Message) return error.response.data.Message;
  if (error.response?.data?.error) {
    const e = error.response.data.error;
    return typeof e === 'string' ? e : JSON.stringify(e);
  }

  // Standard Error object
  if (error.message) return error.message;
  if (error.Message) return error.Message;
  if (error.Error) return error.Error;

  // erpaxios interceptor rejects with raw response.data (e.g. { error: "Access Denied" })
  // auth middleware returns { error: "..." } with lowercase key
  if (error.error) {
    const e = error.error;
    return typeof e === 'string' ? e : JSON.stringify(e);
  }

  // String passed directly
  if (typeof error === 'string') return error;

  return 'An unknown error occurred';
}
  
export const handleAPIResponse = (response, fallback) => {
  if (
    response === undefined || 
    response === null || 
    (Array.isArray(response) && response.length === 0) || 
    (typeof response === 'object' && Object.keys(response).length === 0)
  ) {
    return fallback;
  }
  return response;
};